import React from 'react'
import { hydrate } from 'react-dom'
import { AppContainer } from 'react-hot-loader'
import ensurePolyfills from './utils/ensure-polyfills'
import initTransmit from './utils/init-transmit'
import { getDrs } from './utils/transmit-client'
import makeFetch from './utils/make-fetch'
import createStore from './store/create-store'
import Entry from './entry'

const renderEntry = (Component) =>
  ensurePolyfills(() => {
    const root = document.getElementById('root')
    const store = createStore(window.__STATE__, makeFetch)

    initTransmit()
    Promise.resolve(window.__drsReady)
      .then(() => {
        const drs = getDrs()
        if (drs && typeof drs.clearUser === 'function') {
          return drs.clearUser()
        }
      })
      .catch((err) => {
        if (window.dtrum) {
          window.dtrum.reportError(err)
        }
      })

    hydrate(
      <AppContainer>
        <Component store={store} />
      </AppContainer>,
      root
    )
  })

renderEntry(Entry)

if (module.hot) {
  module.hot.accept('./entry.js', () => {
    /* eslint-disable global-require */
    const RootContainer = require('./entry').default
    renderEntry(RootContainer)
  })
}
